module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }